// extracted by mini-css-extract-plugin
export default {"trigger":"info-tooltip_trigger__HVVIF","tooltip":"info-tooltip_tooltip__87Fii"};